import { createAction } from '@reduxjs/toolkit';
import { SET_CARRIERS } from '../constants';

export const setCarriers = createAction(SET_CARRIERS);

export default { setCarriers };
